import { __assign, __generator } from "tslib";
import { put, select, takeLatest } from 'redux-saga/effects';
import * as actionTypes from '../constants/actionTypes';
import { getHoverStack } from '../selectors/hover';
import { removeFromHoverStack, showHoverScreen, showHoverOverlay, } from '../actionCreators';
export function hoverOut(_a) {
    var hoverStack, currentHotspot;
    var numberOfLevels = _a.numberOfLevels, scrollPos = _a.scrollPos, meta = _a.meta;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, select(getHoverStack)];
            case 1:
                hoverStack = _b.sent();
                currentHotspot = hoverStack[hoverStack.length - numberOfLevels];
                return [4 /*yield*/, put(removeFromHoverStack(numberOfLevels))];
            case 2:
                _b.sent();
                if (currentHotspot.maintainScroll) {
                    // update scrollPos in case user has scrolled while hovered in
                    currentHotspot.scrollPos.current = scrollPos;
                }
                return [4 /*yield*/, put(showHoverScreen(currentHotspot.screenID, currentHotspot.scrollPos, __assign(__assign({ hoverOut: true }, meta), { hotspotID: currentHotspot.id })))];
            case 3:
                _b.sent();
                if (!currentHotspot.layerID) return [3 /*break*/, 5];
                return [4 /*yield*/, put(showHoverOverlay(currentHotspot.layerID, undefined, __assign(__assign({ hoverOut: true }, meta), { hotspotID: currentHotspot.id })))];
            case 4:
                _b.sent();
                _b.label = 5;
            case 5: return [2 /*return*/];
        }
    });
}
export default function watchHoverOut() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeLatest(actionTypes.HOVER_OUT, hoverOut)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
